"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFavoriteProductList = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _utils = require("../utils");
/* istanbul ignore file @preserve --api */

const getFavoriteProductList = async ({
  client,
  customerId
}) => {
  const {
    data
  } = await (0, _globalApiClientReact.getCustomerProductListTypeProductLists)(client, customerId, 'Favorite');
  if (data.productLists[0]) {
    const [list] = data.productLists;
    const {
      productListId
    } = list;
    if (productListId !== undefined) {
      return (0, _utils.mapGlobalApiProductListToList)({
        list: {
          ...list,
          productListId
        },
        type: 'Favorite'
      });
    }
  }
  return null;
};
exports.getFavoriteProductList = getFavoriteProductList;
